import script from "./BeneficiaryAllScheduleModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BeneficiaryAllScheduleModal.vue?vue&type=script&setup=true&lang=ts"

import "./BeneficiaryAllScheduleModal.vue?vue&type=style&index=0&id=d9b710a4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9b710a4"]])

export default __exports__